import type { Resume } from "@adafia/types";
import { GraduationCap, Trash2 } from "lucide-react";
import { SectionHeader } from "./SectionHeader";

interface SkillEditorProps {
	skills: Resume["skills"];
	onAdd: () => void;
	onRemove: (id: string) => void;
}

export function SkillEditor({ skills, onAdd, onRemove }: SkillEditorProps) {
	return (
		<>
			<SectionHeader title="Skills" icon={GraduationCap} onAdd={onAdd} />
			<div style={{ display: "flex", flexWrap: "wrap" }}>
				{skills.map((skill) => (
					<span key={skill.id} className="skill-tag">
						{skill.name}
						<button
							title="Remove Skill"
							type="button"
							onClick={() => onRemove(skill.id)}
							className="skill-delete"
						>
							<Trash2 size={12} />
						</button>
					</span>
				))}
			</div>
		</>
	);
}
